import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';

import { TAddFavoriteRequest, fetchAddFavorite } from '../../repositories/favorites/v1/add-favorite';
import { trackingActionAddFromCardJG } from './tracking';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { IFavoriteThunkResult } from '../../types/redux/thunks';
import { gaLabelSelector, newbuildingIdSelector } from 'shared/selectors/newbuilding';

/* istanbul ignore next */
export const addFavorite = createAsyncThunk<IFavoriteThunkResult, undefined, IThunkApi>(
  'favorites/addFavorite',
  async (_doneText, _thunkApi) => {
    const {
      extra: { httpApi, logger },
      rejectWithValue,
      getState,
    } = _thunkApi;

    const state = getState();

    const gaLabel = gaLabelSelector(state);
    const newbuildingId = newbuildingIdSelector(state);

    const parameters: TAddFavoriteRequest = {
      dealType: 'sale',
      entityType: 'newbuilding',
      entityId: newbuildingId,
    };

    const trackActionRemove = trackingActionAddFromCardJG(gaLabel, newbuildingId);
    await trackActionRemove();

    try {
      const response: { statusCode: number } = await fetchAddFavorite({ httpApi, parameters });

      if (response.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode: response.statusCode,
          message: 'Ошибка запроса в add-favorite',
          domain: 'src/shared/thunks/favorites/favorites.ts',
        });
      }
    } catch (err) {
      logger.error(err, {
        message: err.message,
        stack: err.stack,
        comment: 'Ошибка запроса в add-favorite',
      });

      rejectWithValue(err);
    }

    return {
      isFavorite: true,
    };
  },
);
